let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cYDv1")).then(() => parcelRequire('97IsN'));